import { Children, useEffect } from "react";

import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { TableCore, TdCore } from "src/Pages/components";
import { EditIcon } from "src/Pages/components/Icons/Icons";

import { TableRowCore } from "src/Pages/components/table/@Core/TableRowCore/TableRowCore";
import { ActionPopoverTable } from "src/Pages/components/table/ActionPopover/ActionPopover";

import { useHttpTableUsers } from "./Hooks/useHttpTableUsers";
import { THeadLeads } from "./THead";
import { cpfOurCnpj } from "src/shared/Utils/MaskCpfCnpj";

import {
  FormatDateBR,
  FormatDateBRToDate,
  FormatHoraBRToDate,
} from "src/shared/Utils/FormatDateBR";
import { RotatingCachedIcon } from "src/Pages/components/Icons/RotatingCachedIcon";
import { FilterSidebar } from "../FilterSidebar/FilterSidebar";
import { useContextRoot } from "src/Contexts/Root/RootContext";
import { Chip } from "@mui/material";

export const TableRootClientes = () => {
  const { listUsers } = useContextRoot();
  const {
    setNameSearch,
    itensPerPage,
    currentPage,
    loadingTable,
    nameSearch,
    setAttTable,
    attTable,
  } = useConfigPageContext();
  const { handleGet } = useHttpTableUsers();

  useEffect(() => {
    handleGet();
  }, [attTable, itensPerPage, currentPage, nameSearch]);

  return (
    <TableCore
      heightTable="620px"
      THead={<THeadLeads />}
      qtdList={listUsers.length}
      setNameSearch={setNameSearch}
      filter={<FilterSidebar />}
      cardAdd={{
        title: "Clientes",
        buttons: [
          <RotatingCachedIcon
            onClick={() => setAttTable((item) => !item)}
            isLoading={loadingTable}
            tooltipTitle="Recarregar a página"
          />,
        ],
      }}
    >
      {Children.toArray(
        listUsers.map((item) => {
          return (
            <TableRowCore id={item.idTenant}>
              <TdCore
                values={
                  <ActionPopoverTable
                    optionsList={[
                      {
                        icon: <EditIcon fontSize="small" />,
                        title: "Editar",
                        isDisabled: true,
                        // onClick: () => {
                        //   handleGetIdToEdit(String(item.id), item);
                        // },
                        onClick: () => {
                          console.log(item);
                        },
                      },
                    ]}
                  />
                }
              />
              <TdCore values={item.name} subTitle={item.email} />
              <TdCore values={item.idTenant} subTitle={item.idCustomerAsaas} />

              <TdCore
                textAlign="left"
                values={cpfOurCnpj({ text: item?.phone1 || "", type: "phone" })}
                subTitle={cpfOurCnpj({
                  text: item?.phone2 || "",
                  type: "phone",
                })}
              />
              <TdCore
                textAlign="right"
                values={FormatDateBRToDate(item.createdAt)}
                subTitle={FormatHoraBRToDate(item.createdAt)}
              />

              <TdCore
                textAlign="right"
                values={FormatDateBRToDate(item.lastLogin).split(" - ")[0]}
                subTitle={FormatHoraBRToDate(item.lastLogin)}
              />

              <TdCore
                textAlign="center"
                values={
                  <Chip
                    label={item?.Subscriptions[0]?.statusSubscriptions}
                    color={
                      item?.Subscriptions[0]?.statusSubscriptions === "ACTIVE"
                        ? "success"
                        : "error"
                    }
                  />
                }
              />
              <TdCore
                textAlign="right"
                values={FormatDateBR(item?.Subscriptions[0]?.trialFinishPeriod)}
              />
              <TdCore
                textAlign="center"
                values={item?.Subscriptions[0]?.isStartPayment ? "Sim" : "Não"}
                sxStyle={{
                  color: item?.Subscriptions[0]?.isStartPayment
                    ? "green"
                    : "inherit",
                }}
              />
              <TdCore
                textAlign="right"
                values={FormatDateBR(
                  item?.Subscriptions[0]?.startPayment || ""
                )}
              />
            </TableRowCore>
          );
        })
      )}
    </TableCore>
  );
};
